import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

const LoadingComponent = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
  >
    <LoadingOutlined />
  </div>
);

export default LoadingComponent;
